/* Claude 24.10.2026: sanfte Newsletter-Einblendung "10 % auf deinen ersten Baum" (ES5).
   Erscheint nach der Cookie-Entscheidung, wenn 25 s vergangen sind ODER die Haelfte der Seite gescrollt ist
   (Desktop zusaetzlich einmal bei Exit-Intent). Nie bei offenem Gestalter, im Warenkorb/Kasse, auf der
   Baum-Botschaft/Ueberraschung, B2B-/Partnerseiten, fuer Abonnenten oder Leute mit Code.
   Schliessen = 30 Tage Ruhe, Anmeldung = nie wieder. Anmeldung ueber denselben Endpunkt wie das Pop-up. */
(function () {
  "use strict";
  var w = window, d = document, box = d.getElementById("pt-nls");
  if (!box || w.PTNewsletterSlideIn) return;
  w.PTNewsletterSlideIn = true;
  var API = "https://partner.planet-tree.de/api2/newsletter";
  /* Leslie 01.11.2026: kein automatisches Aufpoppen mehr (Zeit/Scroll/Exit); Karte nur noch ueber das Newsletter-Symbol in der Leiste. Zurueck: NO_AUTO = false */
  var NO_AUTO = true;
  var KEY = "pt-nl-slide-until", DAY = 86400000, start = Date.now(), shown = false, armed = false, exitDone = false;
  var form = d.getElementById("pt-nls-form"), msg = d.getElementById("pt-nls-msg"), email = d.getElementById("pt-nls-email");

  function ls(k, v) { try { if (v === undefined) return w.localStorage.getItem(k); w.localStorage.setItem(k, v); } catch (e) {} return null; }
  function track(name) {
    try { (w.dataLayer = w.dataLayer || []).push({ event: "nl_slidein_" + name, pt_nl: { path: location.pathname } }); } catch (e) {}
    try { if (w.PTGuidedSession && w.PTGuidedSession.track) w.PTGuidedSession.track("nl_slidein_" + name, { path: location.pathname }); } catch (e) {}
  }
  function until(k) { var v = Number(ls(k) || 0); return v && v > Date.now(); }
  function hasCode() {
    try { var s = JSON.parse(ls("pt-nl-discount") || "null"); if (s && s.code) return true; } catch (e) {}
    return /(?:^|;\s*)discount_code=/.test(d.cookie || "");
  }
  function blockedPage() {
    var p = location.pathname.toLowerCase(), q = location.search;
    if (/^\/(cart|checkouts?|orders|account|apps|tools)(\/|$)/.test(p)) return true;
    if (/^\/pages\/(baum-botschaft|fuer-dich|firmen-ueberraschung|unternehmen|zertifikat-personalisieren|testing-|b2b|newsletter)/.test(p) || p.indexOf("b2b") > -1) return true;
    if (/[?&](newsletter|newsletter-confirm|newsletter-privacy|newsletter-unsubscribe|newsletter-resubscribe|newsletter-preview|edit_bundle|admin_edit|ruhe)=/.test(q)) return true;
    var t = (d.body && d.body.getAttribute("data-ptw-template")) || "";
    if (/^(pt-partner|pt-frozen|partner|pt-botschaft|pt-fuerdich|pt-b2b|b2b|pt-personalizer)/.test(t)) return true;
    try { if (w.ShopifyAnalytics && w.ShopifyAnalytics.meta && w.ShopifyAnalytics.meta.page && w.ShopifyAnalytics.meta.page.customerId) return true; } catch (e) {}
    return false;
  }
  function eligible() { return !blockedPage() && !until(KEY) && !until("pt-nl-dismiss-until") && !hasCode(); }
  function cookieDecided() {
    var b = d.getElementById("pt-cookie-banner");
    if (b && b.open) return false;
    if (d.documentElement.className.indexOf("pt-cookie-modal-open") > -1) return false;
    if (ls("pt_consent_choice_v1")) return true;
    try {
      var c = w.Shopify && w.Shopify.customerPrivacy && w.Shopify.customerPrivacy.currentVisitorConsent && w.Shopify.customerPrivacy.currentVisitorConsent();
      if (c && (c.analytics === "yes" || c.analytics === "no")) return true;
    } catch (e) {}
    return false;
  }
  function busyElsewhere() {
    var h = d.documentElement.className + " " + (d.body ? d.body.className : "");
    if (/ptn-lock|ptqQuickFocusOpen/.test(h)) return true;
    var nl = d.getElementById("pt-newsletter"); if (nl && nl.open) return true;
    return false;
  }
  /* Feste Leisten unten (Kaufleiste, Bauchbinde) nicht verdecken: Abstand nach oben schieben */
  function fixedBottomAt(x) {
    /* hoechste feste Leiste im unteren Bereich (Bauchbinde, schwebende Kaufleiste) -> Abstand darueber */
    var vh = w.innerHeight || d.documentElement.clientHeight, best = 0, ys = [4, 40, 80, 120], k, el, n, cs, r, hgt;
    for (k = 0; k < ys.length; k++) {
      el = d.elementFromPoint(x, vh - ys[k]); n = 0;
      while (el && el !== d.body && el !== d.documentElement && n++ < 12) {
        if (el === box || el.id === "pt-cookie-banner") break;
        cs = w.getComputedStyle(el);
        if (cs.position === "fixed" && cs.display !== "none" && cs.visibility !== "hidden") {
          r = el.getBoundingClientRect(); hgt = vh - r.top;
          if (hgt > 0 && hgt < 180 && hgt > best) best = hgt;
          break;
        }
        el = el.parentElement;
      }
    }
    return best;
  }
  function bottomOffset() {
    var mobile = (w.innerWidth || 1000) <= 600, pe = box.style.pointerEvents;
    box.style.pointerEvents = "none";
    var off = Math.max(fixedBottomAt(mobile ? (w.innerWidth || 390) / 2 : 190), mobile ? 0 : Math.max(fixedBottomAt(30), fixedBottomAt((w.innerWidth || 1000) - 190)));
    box.style.pointerEvents = pe;
    return off;
  }
  /* Kauf-/Gestalten-Knoepfe nie verdecken: Seite waehlen, auf der keiner liegt; sonst spaeter erneut versuchen */
  var CTA = /gestalten|warenkorb|kaufen|kasse|bestellen|verschenken|weiter|in den korb|jetzt|bezahlen|ab \d+ ?€/i;
  function ctaIn(r) {
    var els = d.querySelectorAll("a,button,[role=button],input[type=submit]"), i, e, b, txt;
    for (i = 0; i < els.length; i++) {
      e = els[i]; if (box.contains(e) || w.getComputedStyle(e).visibility === "hidden") continue;
      b = e.getBoundingClientRect(); if (b.width < 40 || b.height < 24 || b.height > 90) continue; /* nur knopfgrosse Elemente, keine Produktkarten */
      if (b.right <= r.left + 2 || b.left >= r.right - 2 || b.bottom <= r.top + 2 || b.top >= r.bottom - 2) continue;
      txt = (e.textContent || e.value || e.getAttribute("aria-label") || "").replace(/\s+/g, " ");
      if (CTA.test(txt) || e.hasAttribute("data-ptn-open") || e.getAttribute("name") === "add") return true;
    }
    return false;
  }
  function spot() {
    var vw = w.innerWidth || 1000, vh = w.innerHeight || 800, mobile = vw <= 600, off = bottomOffset();
    var hgt = mobile ? 200 : 270, wid = mobile ? vw : 360, bottom = mobile ? (off ? off + 4 : 0) : 20 + off;
    var top = vh - bottom - hgt;
    if (mobile) return ctaIn({ left: 0, right: vw, top: top, bottom: vh - bottom }) ? null : { side: "full", bottom: bottom };
    var L = { left: 20, right: 20 + wid, top: top, bottom: vh - bottom }, R = { left: vw - 20 - wid, right: vw - 20, top: top, bottom: vh - bottom };
    if (!ctaIn(L)) return { side: "left", bottom: bottom };
    if (!ctaIn(R)) return { side: "right", bottom: bottom };
    return null;
  }
  /* Claude 25.10.2026: Handy – beim Tippen bleibt die Karte direkt ueber der Tastatur, bekommt unten aber einen freien Streifen:
     dort legt Chrome/Safari seine Autofill-Leiste ab, statt das E-Mail-Feld zu verdecken */
  var focusMode = false;
  function vvTop() {
    if (!focusMode) return;
    var vv = w.visualViewport, vt = vv ? vv.offsetTop : 0, vhh = vv ? vv.height : (w.innerHeight || 800);
    box.style.top = Math.max(vt + 8, vt + vhh - box.offsetHeight) + "px";
  }
  function focusOn() {
    if ((w.innerWidth || 1000) > 600 || box.hidden) return;
    focusMode = true; if (!/\bis-focus\b/.test(box.className)) box.className += " is-focus";
    box.style.bottom = "auto"; vvTop(); setTimeout(vvTop, 300); setTimeout(vvTop, 700);
  }
  function focusOff() {
    setTimeout(function () {
      if (d.activeElement && box.contains(d.activeElement) && d.activeElement.tagName === "INPUT" && d.activeElement.type === "email") return;
      if (!focusMode) return;
      focusMode = false; box.className = box.className.replace(/\s*is-focus/g, ""); box.style.top = ""; place();
    }, 200);
  }
  email.addEventListener("focus", focusOn, false);
  email.addEventListener("blur", focusOff, false);
  if (w.visualViewport) { w.visualViewport.addEventListener("resize", vvTop, false); w.visualViewport.addEventListener("scroll", vvTop, false); }
  function place(sp) {
    if (focusMode) return true;
    sp = sp || spot(); if (!sp) return false;
    box.style.bottom = sp.side === "full" ? (sp.bottom ? sp.bottom + "px" : "") : sp.bottom + "px";
    if (sp.side === "right") { box.style.left = "auto"; box.style.right = "20px"; }
    else if (sp.side === "left") { box.style.left = "20px"; box.style.right = "auto"; }
    return true;
  }
  /* Claude 25.10.2026: Handy – solange die Karte offen ist, feste Leisten unten (Bauchbinde, Shop-Leiste) ausblenden,
     damit nicht drei Ebenen uebereinander liegen; beim Schliessen wieder einblenden */
  var hidBars = [];
  function hideBars() {
    var vw = w.innerWidth || 390, vh = w.innerHeight || 800, xs = [0.15, 0.5, 0.85], ys = [4, 40, 80, 120, 170], i, j, el, n, cs;
    box.style.pointerEvents = "none";
    for (i = 0; i < xs.length; i++) for (j = 0; j < ys.length; j++) {
      el = d.elementFromPoint(vw * xs[i], vh - ys[j]); n = 0;
      while (el && el !== d.body && el !== d.documentElement && n++ < 12) {
        if (el === box || el.id === "pt-cookie-banner") break;
        cs = w.getComputedStyle(el);
        if (cs.position === "fixed" && cs.visibility !== "hidden") {
          if (vh - el.getBoundingClientRect().top < 260) { hidBars.push([el, el.style.visibility]); el.style.visibility = "hidden"; }
          break;
        }
        el = el.parentElement;
      }
    }
    box.style.pointerEvents = "";
  }
  function showBars() {
    for (var i = 0; i < hidBars.length; i++) hidBars[i][0].style.visibility = hidBars[i][1];
    hidBars = [];
  }
  function show(how) {
    if (shown || !eligible() || busyElsewhere()) return;
    var mob = (w.innerWidth || 1000) <= 600;
    if (mob) hideBars();
    var sp = spot(); if (!sp) { showBars(); return; }
    shown = true; box.hidden = false; place(sp);
    setTimeout(function () { box.className += " is-on"; }, 30);
    track("shown"); track("shown_" + how);
  }
  function hide(days) {
    box.className = box.className.replace(/\s*is-on/g, "");
    setTimeout(function () { box.hidden = true; showBars(); }, 380);
    if (days) ls(KEY, String(Date.now() + days * DAY));
  }
  function tick() {
    if (NO_AUTO) { stop(); return; }
    if (shown) return;
    if (!eligible()) { stop(); return; }
    if (!cookieDecided() || busyElsewhere()) return;
    var doc = d.documentElement, sc = (w.pageYOffset || doc.scrollTop || 0) + (w.innerHeight || 0), hgt = Math.max(doc.scrollHeight, d.body ? d.body.scrollHeight : 0);
    if (Date.now() - start >= 25000) show("zeit");
    else if (hgt > 0 && sc / hgt >= 0.5 && doc.scrollHeight > (w.innerHeight || 0) * 1.5) show("scroll");
  }
  var timer = null;
  function stop() { if (timer) { clearInterval(timer); timer = null; } }

  box.querySelector("[data-nls-close]").addEventListener("click", function () { hide(30); track("closed"); }, false);
  d.addEventListener("keydown", function (e) { if (shown && !box.hidden && (e.key === "Escape" || e.keyCode === 27) && box.contains(d.activeElement)) { hide(30); track("closed"); } }, false);
  w.addEventListener("resize", function () { if (shown && !box.hidden) place(); }, false);
  var st = 0;
  w.addEventListener("scroll", function () { if (shown && !box.hidden && !st) st = setTimeout(function () { st = 0; place(); }, 200); }, { passive: true });
  /* Desktop: einmal beim Verlassen des Fensters nach oben (Exit-Intent) */
  d.addEventListener("mouseout", function (e) {
    if (NO_AUTO || !armed || exitDone || shown || (w.innerWidth || 0) <= 900 || e.relatedTarget || e.toElement) return;
    if ((e.clientY || 0) > 8) return;
    if (!cookieDecided() || busyElsewhere() || !eligible()) return;
    exitDone = true; show("exit");
  }, false);

  function note(title, text, err) {
    msg.innerHTML = "";
    if (title) { var s = d.createElement("strong"); s.appendChild(d.createTextNode(title)); msg.appendChild(s); }
    msg.appendChild(d.createTextNode(text)); msg.setAttribute("data-error", err ? "true" : "false"); msg.hidden = false;
  }
  form.addEventListener("submit", function (e) {
    e.preventDefault();
    var mail = (email.value || "").replace(/^\s+|\s+$/g, ""), ok = form.elements.consent.checked;
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) { note("", "Bitte gib eine gültige E-Mail-Adresse ein.", true); email.focus(); return; }
    if (!ok) { note("", "Bitte setz noch das Häkchen für die Waldpost.", true); return; }
    var btn = form.querySelector("button[type=submit]"); btn.disabled = true; btn.textContent = "Moment …";
    var x = new XMLHttpRequest();
    x.open("POST", API + "/subscribe", true);
    x.setRequestHeader("Content-Type", "application/json");
    x.timeout = 15000;
    x.onreadystatechange = function () {
      if (x.readyState !== 4) return;
      btn.disabled = false; btn.textContent = "Code holen";
      var data = null; try { data = JSON.parse(x.responseText || "null"); } catch (er) {}
      if (x.status >= 200 && x.status < 300) {
        ls(KEY, String(Date.now() + 3650 * DAY)); ls("pt-nl-dismiss-until", String(Date.now() + 365 * DAY));
        form.hidden = true;
        note("Fast geschafft – schau in dein Postfach.", "Bestätige die Anmeldung in der Mail, dann kommt dein persönlicher Rabattcode. Bitte auch im Spam-Ordner nachsehen.", false);
        track("submitted");
        setTimeout(function () { hide(0); }, 12000);
      } else {
        note("Noch nicht erledigt.", (data && typeof data.detail === "string") ? data.detail : "Die Anmeldung hat gerade nicht funktioniert. Bitte versuche es gleich noch einmal.", true);
      }
    };
    x.ontimeout = function () { btn.disabled = false; btn.textContent = "Code holen"; note("Noch nicht erledigt.", "Die Rückmeldung dauert zu lange. Bitte schau nach der Bestätigungsmail oder versuche es später erneut.", true); };
    x.send(JSON.stringify({ email: mail, consent: true, consent_version: "2026-09-22-v2", website: form.elements.website.value, source: "/slidein" + location.pathname }));
  }, false);

  if (!eligible()) return;
  /* Nur anbieten, wenn die Anmeldung serverseitig aktiv ist */
  var c = new XMLHttpRequest();
  c.open("GET", API + "/config", true);
  c.onreadystatechange = function () {
    if (c.readyState !== 4) return;
    var cfg = null; try { cfg = JSON.parse(c.responseText || "null"); } catch (e) {}
    if (c.status === 200 && cfg && cfg.enabled) { armed = true; timer = setInterval(tick, 1000); }
  };
  c.send();
})();
